import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filter'
})
export class FilterPipe implements PipeTransform {

  transform(items: Array<any>, fields: Array<string>, searchText: string): any {
    if (!items) {
      return [];
    }
    return (!searchText) ? items : this.getSearchResult(items, fields, searchText);
   }

  private getSearchResult(items: Array<any>, fields: Array<string>, searchText: string): any {
    searchText = searchText.toLowerCase();
    let searchResult: Array<any> = [];
    fields.forEach(field => {
      searchResult = searchResult.concat(items
        .filter(it => !!it[field])
        .filter(it => it[field].toLowerCase().includes(searchText)));
    });
    return Array.from(new Set(searchResult));
  }
}
